import { render, staticRenderFns } from "./menu.aside.vue?vue&type=template&id=4135a486&"
import script from "./menu.aside.vue?vue&type=script&lang=ts&"
export * from "./menu.aside.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports